import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 22V4c0-.5.2-1 .6-1.4C5 2.2 5.5 2 6 2h8.5L20 7.5V20c0 .5-.2 1-.6 1.4-.4.4-.9.6-1.4.6h-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "10", cy: "20", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 7V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 12v-1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18v-2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileArchive";
const FileArchive = memo(themed(Icon));
export {
  FileArchive
};
//# sourceMappingURL=file-archive.js.map
